import { render, staticRenderFns } from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal-basic-form.vue?vue&type=template&id=e0571508&scoped=true&"
import script from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal-basic-form.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal-basic-form.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-grossing-shelf-immediate-shelf-priority-modal-basic-form.scss?vue&type=style&index=0&id=e0571508&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0571508",
  null
  
)

export default component.exports